import { clearInputPlaceholder } from "dynamic/components/FormComponents/Input/masks";
import { ZIP_CODE_LENGTH } from "constants/inputMasks";

/**
 * Validates one zip code / PLZ code according to German standards.
 * @param {*} value The value
 */
const isValidZipCode = (value) => {
  const parsedZipCode = clearInputPlaceholder(value ?? "");

  return (
    parsedZipCode
    && parsedZipCode.length === ZIP_CODE_LENGTH
  );
};

export default isValidZipCode;
